export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10089.2cf94cb1.jpg";